module.exports = __webpack_public_path__ + "static/media/bulk-template.c1b94e44.csv";